import {Box, Button, Menu, MenuItem, Typography} from "@material-ui/core";
import {useCallback, useRef, useState} from "react";
import {LicenseManager} from "ag-grid-enterprise";
import {AgGridReact} from "ag-grid-react";
import fnOpenToast from "../../components/toast";
import "react-toastify/dist/ReactToastify.css";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import EditIcon from "@material-ui/icons/Edit";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import RedoIcon from "@material-ui/icons/Redo";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import {Link as ReactLink} from "react-router-dom";
import CreateTemplateConditionLineDialog from "../../components/createTemplateConditionLineDialog";
import {
    getTemplateConditionLinesOptions,
    createTemplateConditionLine,
    getTemplateConditionLines,
    updateTemplateConditionLines,
} from "../../api";
import {getTemplates} from "../../api/docusign-templates";
import withTemplateGridMultiSelectCheckbox from "../../hocs/withTemplateGridMultiSelectCheckbox";
import MultiSelectCheckbox from "../../components/multiSelectCheckbox";

LicenseManager.setLicenseKey(
    "Using_this_AG_Grid_Enterprise_key_( AG-044136 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Lucid USA, Inc )_is_granted_a_( Single Application )_Developer_License_for_the_application_( V360 )_only_for_( 1 )_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_( V360 )_need_to_be_licensed___( V360 )_has_been_granted_a_Deployment_License_Add-on_for_( 2 )_Production_Environments___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 28 August 2024 )____[v2]_MTcyNDc5OTYwMDAwMA==c89ee173c77380f5ddc3c6af80f11777",
);

const initialValue = {
    formName: {
        value: "",
        hasError: false,
    },
    formId: {
        value: "",
        hasError: false,
    },
    State: {
        value: [],
        hasError: false,
    },
    TransactionType: {
        value: [],
        hasError: false,
    },
    PurchaseType: {
        value: [],
        hasError: false,
    },
    CoBuyer: {
        value: [],
        hasError: false,
    },
    InstallFrontPlate: {
        value: [],
        hasError: false,
    },
    SpecialApplicabilityCondition: {
        value: [],
        hasError: false,
    },
    isActive: {
        value: true,
        hasError: false,
    },
};

function TemplateConditionLine() {
    const gridRef = useRef();
    const [gridApi, setGridApi] = useState(null);
    const [tableData, setTableData] = useState(null);
    const [enableEditing, setEnableEditing] = useState(false);
    const [rowsUpdated, setRowsUpdated] = useState(new Map());
    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState(initialValue);
    const [templateConditionLineOption, setTemplateConditionLineOption] =
        useState({});
    const [templateFormNameOption, setTemplateFormNameOption] = useState(
        new Map(),
    );

    const columnDefs = [
        {
            headerName: "Docusign Template Name",
            field: "name",
            width: 350,
            cellEditor: "agRichSelectCellEditor",
            cellEditorParams: (params) => {
                return {
                    values: templateFormNameOption
                };
            },
            valueFormatter: (params) => params.value ? params.value.label : '',
            valueSetter: (params) => {
                const selectedOption = templateFormNameOption.find(option => option.value === params.newValue.value);
                if (!selectedOption) {
                    return false;
                }

                params.data.name = selectedOption.label;
                params.data.docusignTemplateId = selectedOption.value;
                params.data.templateId = selectedOption.id;
                return true;
            },
            valueGetter: (params) => {
                return params.data.name;
            },
            filter: 'agSetColumnFilter',
            filterParams: {
                values: (params) => {
                    return params.success(Array.from(new Set(params.api.getModel().rowsToDisplay.map(row => row.data.name))));
                },
            }
        },
        {
            headerName: "Docusign Template ID",
            field: "docusignTemplateId",
            editable: false,
            width: 350,
            filter: 'agSetColumnFilter',
            filterParams: {
                values: (params) => {
                    return params.success(Array.from(new Set(params.api.getModel().rowsToDisplay.map(row => row.data.docusignTemplateId))));
                },
            }
        },
        {
            headerName: "States",
            field: "states",
            width: 200,
            cellEditor: withTemplateGridMultiSelectCheckbox(MultiSelectCheckbox),
            cellEditorParams: (params) => {
                return {
                    values: templateConditionLineOption?.states ?? [],
                    eGridCell: params.eGridCell,
                    isRequired: true
                };
            },
            cellRenderer: ({value}) => {
                return value?.join(", ");
            },
            valueSetter: (params) => {
                params.data.states = params.newValue;
                return true;
            },
            valueGetter: (params) => {
                return params.data.states;
            },
        },
        {
            headerName: "Transaction Type",
            field: "conditions.transactionType",
            width: 350,
            cellEditor:
                withTemplateGridMultiSelectCheckbox(MultiSelectCheckbox),
            cellEditorParams: (params) => {
                return {
                    values: templateConditionLineOption?.transactionType ?? [],
                    eGridCell: params.eGridCell,
                    isRequired: true
                };
            },
            cellRenderer: ({value}) => {
                return value?.join(", ");
            },
            valueSetter: ({data, newValue}) => {
                data.conditions.transactionType = newValue;
            },
        },
        {
            headerName: "Purchase Type",
            field: "conditions.purchaseType",
            width: 350,
            cellEditor:
                withTemplateGridMultiSelectCheckbox(MultiSelectCheckbox),
            cellEditorParams: (params) => {
                return {
                    values: templateConditionLineOption?.purchaseType ?? [],
                    eGridCell: params.eGridCell,
                    isRequired: true
                };
            },
            cellRenderer: ({value}) => {
                return value?.join(", ");
            },
            valueSetter: ({data, newValue}) => {
                data.conditions.purchaseType = newValue;
            },
        },
        {
            headerName: "CoBuyer",
            field: "conditions.coBuyer",
            width: 200,
            cellEditor:
                withTemplateGridMultiSelectCheckbox(MultiSelectCheckbox),
            cellEditorParams: (params) => {
                return {
                    values: templateConditionLineOption?.coBuyer ?? [],
                    eGridCell: params.eGridCell,
                    isRequired: true
                };
            },
            cellRenderer: ({value}) => {
                return value?.join(", ");
            },
            valueSetter: ({data, newValue}) => {
                const transformedCoBuyerField = newValue.map(
                    (str) => str === "true",
                );
                data.conditions.coBuyer = transformedCoBuyerField;
            },
        },
        {
            headerName: "InstallFrontPlate",
            field: "conditions.installFrontPlate",
            width: 200,
            cellEditor:
                withTemplateGridMultiSelectCheckbox(MultiSelectCheckbox),
            cellEditorParams: (params) => {
                return {
                    values:
                        templateConditionLineOption?.installFrontPlate ?? [],
                    eGridCell: params.eGridCell,
                    isRequired: true
                };
            },
            cellRenderer: ({value}) => {
                return value?.join(", ");
            },
            valueSetter: ({data, newValue}) => {
                const transformedinstallFrontPlateField = newValue.map(
                    (str) => str === "true",
                );
                data.conditions.installFrontPlate =
                    transformedinstallFrontPlateField;
            },
        },
        {
            headerName: "Is Active",
            field: "isActive",
            cellRenderer: 'agCheckboxCellRenderer',
            cellEditor: 'agCheckboxCellEditor',
            editable: true,
        },
        {
            headerName: "Special Applicability Conditions",
            field: "specialApplicabilityConditions",
            width: 400,
            cellEditor:
                withTemplateGridMultiSelectCheckbox(MultiSelectCheckbox),
            cellEditorParams: (params) => {
                return {
                    values:
                        templateConditionLineOption?.specialApplicabilityConditions ??
                        [],
                    eGridCell: params.eGridCell,
                    isRequired: false
                };
            },
            cellRenderer: ({value}) => {
                return value?.join(", ");
            },
            valueSetter: ({data, newValue}) => {
                data.specialApplicabilityConditions = newValue;
            },
        },
    ];

    const [anchorEl, setAnchorEl] = useState(null);

    const handleActionClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleActionClose = useCallback(() => {
        setAnchorEl(null);
    }, []);

    const handleEnableEdit = () => {
        setEnableEditing(true);
    };

    const refreshData = async () => {
        try {
            const [templatesData, getTemplateConditionLinesData] =
                await Promise.all([
                    getTemplates(),
                    getTemplateConditionLines(),
                ]);

            const templates = new Map();
            const formNameOptionArr = [];

            templatesData.forEach((item) => {
                templates.set(item._id, {
                    name: item.name,
                    docusignTemplateId: item.docusignTemplateId,
                });
                if (item?.isActive) {
                    const { name, docusignTemplateId, _id } = item;
                    const templateFormNameOption = {
                        label: name,
                        value: docusignTemplateId,
                        id: _id,
                    };
                    formNameOptionArr.push(templateFormNameOption);
                }
            });

            setTemplateFormNameOption(formNameOptionArr);
            const formattedResponse = getTemplateConditionLinesData.map(
                (data) => {
                    return {
                        ...data,
                        name: templates.get(data.templateId)?.name,
                        docusignTemplateId: templates.get(data.templateId)
                            ?.docusignTemplateId,
                    };
                }
            );

            setTableData(formattedResponse);
        } catch (error) {
            fnOpenToast(error?.message || "Oops Something Went Wrong!", "error");
        }
    };

    const handleFormSubmit = async (event) => {
        try {
            event.preventDefault();
            const request = constructRequest(formData);
            await createTemplateConditionLine(request);
            handleClose();
            refreshData();
            fnOpenToast(
                "Template Condition Line Saved Successfully!!!",
                "success",
            );
        } catch (error) {
            fnOpenToast(error?.message || "Oops Something Went Wrong!", "error");
        }
    };

    const formatFieldValues = (field) => field?.map((option) => option?.name);

    const formatFieldValuesToBoolean = (field) => {
        const namesArray = field?.map(option => option?.name);
        return namesArray?.map(name => name === "true");
    }
    
    const constructRequest = (formData) => {
        const {
            State: {value: states},
            CoBuyer: {value: coBuyer},
            InstallFrontPlate: {value: installFrontPlate},
            TransactionType: {value: transactionType},
            PurchaseType: {value: purchaseType},
            SpecialApplicabilityCondition: {
                value: specialApplicabilityConditions,
            },
            isActive: {value: isActive},
        } = formData;

        const templateId = templateFormNameOption.find(t => t.value === formData.formId.value)?.id;
        const request = {
            templateId,
            states: formatFieldValues(states),
            conditions: {
                coBuyer: formatFieldValuesToBoolean(coBuyer),
                installFrontPlate: formatFieldValuesToBoolean(installFrontPlate),
                transactionType: formatFieldValues(transactionType),
                purchaseType: formatFieldValues(purchaseType),
            },
            specialApplicabilityConditions: formatFieldValues(
                specialApplicabilityConditions,
            ),
            isActive,
        };

        return request;
    };

    const onChange = (e) => {
        const {value, id, name} = e.target;
        setFormData({
            ...formData,
            [id ?? name]: {value: value, hasError: false},
        });
    };

    const onFormNameChange = (e) => {
        const {value} = e.target;
        setFormData({...formData, formId: {value: value, hasError: false}});
    };

    const onChecked = (e) => {
        const {checked, id} = e.target;
        setFormData({...formData, [id]: {value: checked, hasError: false}});
    };

    const onGridReady = (params) => {
        setGridApi(params);
        getInitialData();
    };

    const getTemplateStateConditonOptions = async () => {
        const generateBooleanOptions = () => [
            {id: 1, name: "true"},
            {id: 2, name: "false"},
        ];

        const templateOptionsResponse =
            await getTemplateConditionLinesOptions();

        const templateOptions = Object.fromEntries(
            Object.entries(templateOptionsResponse).map(([key, options]) => [
                key,
                options.map((name, index) => ({
                    id: index + 1,
                    name,
                })),
            ]),
        );

        templateOptions["coBuyer"] = generateBooleanOptions();
        templateOptions["installFrontPlate"] = generateBooleanOptions();

        setTemplateConditionLineOption(templateOptions);
    };

    const getInitialData = async () => {
        getTemplateStateConditonOptions();
        refreshData();
    };

    const modifyAndExtractTemplateConditionFields = (data) => {
        return data.map((item) => {
            return {
                templateId: item.templateId,
                states: item.states,
                conditions: {
                    coBuyer: item.conditions.coBuyer,
                    installFrontPlate: item.conditions.installFrontPlate,
                    transactionType: item.conditions.transactionType,
                    purchaseType: item.conditions.purchaseType,
                },
                specialApplicabilityConditions:
                item.specialApplicabilityConditions,
                isActive: item.isActive,
                _id: item._id,
            };
        });
    };

    const handleSaveEdited = () => {
        const editedRows = Array.from(rowsUpdated.values());
        if (editedRows.length === 0) {
            fnOpenToast("Edit one or more records to update!", "error");
            return;
        }

        const transformedRows =
            modifyAndExtractTemplateConditionFields(editedRows);

        handleUpdateTemplateConditionLine(transformedRows);
        setRowsUpdated(new Map());
    };

    const handleUpdateTemplateConditionLine = async (editedRows) => {
        const updateRequest = editedRows;
        const confirm = window.confirm(
            `Are you sure you want to update ${editedRows.length} items?`,
        );
        if (!confirm) {
            return;
        }

        setEnableEditing(false);
        try {
            await updateTemplateConditionLines(updateRequest);
            fnOpenToast(
                "Template Condition Line Updated Successfully!",
                "success",
            );
        } catch (error) {
            fnOpenToast(error?.message || "Oops Something Went Wrong!", "error");
        }

        refreshData();
    };

    const handleCancelEdit = () => {
        setEnableEditing(false);
        setRowsUpdated(new Map());
        refreshData();
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setFormData({
            ...formData,
            formId: {
                ...formData.formId,
                value: "",
                hasError: false,
            },
        });
    };

    const handleCellValueChanged = (params) => {
        const updatedData = {...params.data};
        if (params.column.colId === "isActive") {
            updatedData.isActive = params.newValue;
        }
        setRowsUpdated(rowsUpdated.set(updatedData._id, updatedData));
    };

    const defaultColDef = {
        sortable: true,
        filter: true,
        floatingFilter: true,
        editable: enableEditing,
        resizable: true,
        minWidth: 100,
    };

    return (
        <div>
            <div style={{margin: "10px 20px"}}>
                <Breadcrumbs aria-label="breadcrumb">
                    <ReactLink
                        color="inherit"
                        to="/"
                        className="breadcrumb-link"
                    >
                        Dashboard
                    </ReactLink>
                    <ReactLink
                        color="inherit"
                        to="/templates-management"
                        className="breadcrumb-link"
                    >
                        Templates
                    </ReactLink>
                    <Typography color="textPrimary">
                        Template Condition Line
                    </Typography>
                </Breadcrumbs>
            </div>
            <Box
                display="flex"
                justifyContent="space-between"
                style={{margin: "10px 20px"}}
            >
                <div>
                    <Typography
                        variant="h5"
                        component={"h5"}
                        style={{
                            fontFamily: "GTAmericaMedium",
                            fontSize: "24px",
                            lineHeight: "120%",
                            fontWeight: "500",
                        }}
                    >
                        Template Condition Line
                    </Typography>
                </div>
                <>
                    <Button
                        variant="outlined"
                        color="primary"
                        aria-controls="action-menu"
                        aria-haspopup="true"
                        onClick={handleActionClick}
                    >
                        Actions <ExpandMoreIcon/>
                    </Button>
                    <Menu
                        id="action-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleActionClose}
                    >
                        <MenuItem onClick={handleEnableEdit}>
                            <EditIcon
                                fontSize="small"
                                style={{marginRight: "5px"}}
                            />{" "}
                            Enable Editing
                        </MenuItem>
                        <MenuItem
                            onClick={handleSaveEdited}
                            disabled={!enableEditing}
                        >
                            <CheckCircleOutlineIcon
                                fontSize="small"
                                style={{marginRight: "5px"}}
                            />{" "}
                            Save Changes
                        </MenuItem>
                        <MenuItem
                            onClick={handleCancelEdit}
                            disabled={!enableEditing}
                        >
                            <RedoIcon
                                fontSize="small"
                                style={{marginRight: "5px"}}
                            />{" "}
                            Cancel Changes
                        </MenuItem>
                        <MenuItem
                            onClick={handleClickOpen}
                            disabled={enableEditing}
                        >
                            <AddCircleOutlineIcon
                                fontSize="small"
                                style={{marginRight: "5px"}}
                            />{" "}
                            Add Template Condition Line
                        </MenuItem>
                    </Menu>
                </>
            </Box>
            <table
                style={{
                    margin: "0 20px",
                    width: "calc(100% - 40px)",
                    height: "calc(100vh - 170px)",
                }}
            >
                <tbody>
                <tr>
                    <td style={{border: "1px solid #babfc7"}}>
                        <div
                            className="ag-theme-alpine"
                            style={{
                                height: "100%",
                                width: "100%",
                            }}
                        >
                            <AgGridReact
                                rowSelection="multiple"
                                ref={gridRef}
                                onGridReady={onGridReady}
                                rowData={tableData}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                                onCellValueChanged={handleCellValueChanged}
                                getRowId={(params) => params.data._id}
                            />

                            <CreateTemplateConditionLineDialog
                                open={open}
                                handleClose={handleClose}
                                data={formData}
                                onChange={onChange}
                                onFormNameChange={onFormNameChange}
                                onChecked={onChecked}
                                handleFormSubmit={handleFormSubmit}
                                templateConditionLineOption={
                                    templateConditionLineOption
                                }
                                templateFormNameOption={
                                    templateFormNameOption
                                }
                            />
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
}

export default TemplateConditionLine;
